import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import styled from "styled-components";
export var LiItem = function LiItem(_ref) {
  var step = _ref.step,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(LiRow, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "GoJsKt",
    defaultMessage: "{stepNumber}.",
    values: {
      stepNumber: step
    }
  })), /*#__PURE__*/React.createElement(Spacer, {
    width: "1x"
  }), /*#__PURE__*/React.createElement(Column, null, children));
};
var LiRow = styled.li.withConfig({
  displayName: "LiItem__LiRow"
})(["display:flex;flex-direction:row;align-items:flex-start;"]);